import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

// core components
import AuthFooter from '../components/Footers/AuthFooter.js';
import { loadStripe } from '@stripe/stripe-js';

import {
  Spinner,
  Container,
  Button,
  Badge,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Alert,
  Modal,
  Collapse,
} from 'reactstrap';
import Countdown from 'react-countdown';

import utils from '../utils';
import AdminNavbar from '../components/Navbars/AdminNavbar';

const LITE_QTY_DEFAULT = 3;

const keyData = {
  KEK25: {},

  AO25: {},

  TPC25: {},
  TED25: {},
  TRS25: {},
  TAM25: {},
  TAK25: {},
  TDV25: {},
  TLA25: {},
  TSA25: {},
  TWP25: {},
  THP25: {},
  TUP25: {},
  THS25: {},
  TDP25: {},
  THC25: {},
  TAA25: {},

  // FB
  LAST25: {},
};

// If a fetch error occurs, log it to the console
async function handleFetchResult(result) {
  if (!result.ok) {
    return result.json().then(function (json) {
      if (json.error && json.error.message) {
        throw new Error(
          result.url + ' ' + result.status + ' ' + json.error.message
        );
      }
    });
  }
  return result.json();
}

const ENDPOINT = utils.isDevMode()
  ? 'http://localhost:4200/stripe'
  : 'https://api.snailbot.io/stripe';

// Create a Checkout Session with the selected plan ID
function createCheckoutSession(data) {
  return fetch(ENDPOINT + '/create-checkout-session', {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}

function getSetup() {
  return fetch(ENDPOINT + '/setup', {
    credentials: 'include',
  });
}

class AmAccountModal extends React.Component {
  state = {
    exampleModal: false,
  };
  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };
  render() {
    return (
      <>
        <div
          className="py-1"
          style={{ cursor: 'pointer', color: '#5cd79c' }}
          onClick={() => this.toggleModal('exampleModal')}
        >
          <b>Help me choose</b>
        </div>
        <Modal
          className="modal-dialog-centered"
          style={{ maxWidth: '800px' }}
          isOpen={this.state.exampleModal}
          toggle={() => this.toggleModal('exampleModal')}
          animation={false}
        >
          <div className="modal-header mb-0 pb-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal('exampleModal')}
            >
              <span aria-hidden={true} style={{ fontSize: '41px' }}>
                ×
              </span>
            </button>
          </div>
          <div className="modal-body px-6 pb-5">
            <div className="text-center pb-3">
              <h1>How many Amazon accounts to use?</h1>
            </div>

            <div>
              We strongly recommend <b>at least 3 accounts</b> for the best
              success potential and redundancy in case of failure.
            </div>
            <br />

            <div>
              Amazon typically only lets you buy one console per account each
              drop. To buy more, you can use 3 different accounts with the same
              info so you can buy 3 PS5s in a drop instead of only 1.
            </div>
            <br />

            <div>
              To use 4 accounts or more, you will need accounts that use
              different info so Amazon can't link them to your other accounts
              and cancel your orders for quantity limit abuse (QLA).
            </div>
            <br />

            <div>
              We have a detailed guide on how to bypass QLA so you can
              effectively use 4 accounts or more. We're also available to help
              you 1-on-1.
            </div>
            <br />
          </div>
        </Modal>
      </>
    );
  }
}

class TgAccountModal extends React.Component {
  state = {
    exampleModal: false,
  };
  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };
  render() {
    return (
      <>
        <div
          className="py-1"
          style={{ cursor: 'pointer', color: '#5cd79c' }}
          onClick={() => this.toggleModal('exampleModal')}
        >
          <b>Help me choose</b>
        </div>
        <Modal
          className="modal-dialog-centered"
          style={{ maxWidth: '800px' }}
          isOpen={this.state.exampleModal}
          toggle={() => this.toggleModal('exampleModal')}
          animation={false}
        >
          <div className="modal-header mb-0 pb-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal('exampleModal')}
            >
              <span aria-hidden={true} style={{ fontSize: '41px' }}>
                ×
              </span>
            </button>
          </div>
          <div className="modal-body px-6 pb-5">
            <div className="text-center pb-3">
              <h1>How many Target accounts to use?</h1>
            </div>

            <div>
              We strongly recommend <b>at least 3 accounts</b> for the best
              success potential and redundancy in case of failure.
            </div>
            <br />

            <div>
              Target typically only lets an account buy the same high demand
              item once every 24h. To buy more, you can use multiple accounts.
              Each account should have different info for everything for best
              success (name, credit card, shipping/billing address, etc).
            </div>
            <br />
            <br />
          </div>
        </Modal>
      </>
    );
  }
}

class FAQItem extends React.Component {
  state = {
    isOpen: this.props.defaultOpen || false,
  };

  toggle = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render() {
    return (
      <>
        <div
          className="mb-4"
          style={{
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '8px',
            padding: '16px',
            cursor: 'pointer',
          }}
          onClick={this.toggle}
        >
          <div className="d-flex align-items-center">
            <b>{this.props.question}</b>
            <i
              className={`fas fa-chevron-${
                this.state.isOpen ? 'up' : 'down'
              } ml-auto`}
              style={{ fontSize: '0.8rem' }}
            />
          </div>
          <Collapse isOpen={this.state.isOpen}>
            <div className="mt-3">{this.props.children}</div>
          </Collapse>
        </div>
      </>
    );
  }
}

class Subscribe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validKey: false,
      redirect: null,
      isLoadingCheckout: false,
      checkbox1: false,
      checkbox2: false,
      errorMessage: null,
      minMonths: 1,
      acceptedCheaterWarning: false,
      acceptedDisclaimer: false,
      ip: null,
      location: null,
      amAccQty: LITE_QTY_DEFAULT,
      tgAccQty: LITE_QTY_DEFAULT,
      activeLicenseType: null,
      isAlreadySubbed: false,
      alreadySubbedModal: false,
      planView: utils.getUrlParamVal('plan'),
      action: utils.getUrlParamVal('action'),
      key: utils.getUrlParamVal('key'),
    };
    this.validateKey = this.validateKey.bind(this);
    this.handleKeyInput = this.handleKeyInput.bind(this);
    this.purchase = this.purchase.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  async componentDidMount() {
    document.body.classList.add('bg-default');

    if (this.props.license) {
      const { licenseStatus, isProEligible, licenseType } = this.props.license;
      if (licenseStatus === 'active') {
        // if (
        //   this.state.planView !== 'lite' &&
        //   (!licenseType ||
        //     !isProEligible ||
        //     (this.props.user &&
        //       utils.isProUpgradeExpired(
        //         this.props.user.notifyProUpgradeISOTime
        //       )))
        // ) {
        //   this.setState({
        //     redirect: '/',
        //   });
        //   return;
        // }
        this.setState({
          activeLicenseType: licenseType || 'pro',
          licenseType: this.props.license.licenseType,
        });
      }
    }

    const { pk } = await handleFetchResult(await getSetup());
    this.stripe = await loadStripe(pk);

    // const { ip, location } = await utils.getIPData();
    // this.setState({
    //   ip,
    //   location,
    // });
  }

  componentWillUnmount() {
    document.body.classList.remove('bg-default');
  }

  handleCheckbox(checkboxName) {
    const checkboxState = this.state[checkboxName];
    // this.state[checkboxName] = !checkboxState; // wtf?
    this.setState({
      [checkboxName]: !checkboxState,
    });
  }

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  renderAlreadySubbedModal = () => {
    return (
      <>
        <Modal
          className="modal-dialog-centered"
          style={{ maxWidth: '800px' }}
          isOpen={this.state.alreadySubbedModal}
          toggle={() => this.toggleModal('alreadySubbedModal')}
          animation={false}
        >
          <div className="modal-header mb-0 pb-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal('alreadySubbedModal')}
            >
              <span aria-hidden={true} style={{ fontSize: '41px' }}>
                ×
              </span>
            </button>
          </div>
          <div className="modal-body px-6 pb-5">
            <div className="text-center pb-3">
              <h1>You already have a subscription. Redirecting...</h1>
              <br />
              <div>
                To change your number of Lite instances, click "
                <b>Update quantity</b>" in the billing portal.
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  };

  async purchase(pricePackage, quantity, requireTerms) {
    if (requireTerms && (!this.state.checkbox1 || !this.state.checkbox2)) {
      this.setState({
        errorMessage: 'You must agree to the terms before proceeding.',
      });
      return;
    }
    this.setState({
      isLoadingCheckout: true,
    });
    let result = await createCheckoutSession({
      // ip: this.state.ip,
      // location: this.state.location,
      key: this.state.key,
      user: this.props.user,
      pricePackage,
      quantity,
    });
    const { sessionId, isAlreadySubbed } = await handleFetchResult(result);
    if (isAlreadySubbed) {
      this.setState({
        isAlreadySubbed,
        alreadySubbedModal: true,
      });
      await utils.sleep(5000);
      window.location.href = `${utils.getEndpoint()}/stripe/customer-portal`;
      return;
    }
    if (!sessionId) {
      return;
    }
    result = this.stripe.redirectToCheckout({
      sessionId,
    });
  }

  handleKeyInput(e) {
    this.setState({ key: e.target.value });
  }

  validateKey(e) {
    if (e) e.preventDefault();

    // Clear error box state
    this.setState({ errorMessage: null });

    if (!this.state.key) {
      this.setState({ errorMessage: 'Please enter your invite code.' });
      return;
    }

    const keyData = this.getKeyData();
    if (keyData) {
      if (keyData.expireTime && keyData.expireTime < Date.now()) {
        this.setState({
          errorMessage: 'Code expired. Feel free to join our waitlist again.',
        });
      } else {
        this.setState({ validKey: true, minMonths: 1, planView: 'pro' });
      }
    } else {
      this.setState({ errorMessage: 'Invalid code.' });
    }
  }

  renderErrors() {
    if (this.state.errorMessage) {
      return <Alert color="danger">{this.state.errorMessage}</Alert>;
    }
  }

  renderRedirect() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
  }

  oldRenderFAQ() {
    return (
      <Container className="text-gray mt-4">
        <b className="display-4">FAQs</b>
        <div className="mb-3">
          <b className="text-underline">
            What makes SnailBot <i>unique</i>?
          </b>
          <div>
            <b>Cloud-based:</b> SnailBot is one of the first <i>cloud-based</i>{' '}
            checkout bots to hit the market, and the only bot we know of that
            consistently succeeds on Newegg.
          </div>
          <div>
            <b>Experience:</b> The lead dev, @etcher, hopes to bring his
            experience working at a big 5 tech company (FAANG) to spearhead the
            next generation of automation software. If you're an experienced bot
            developer, DM @etcher for opportunities to join the team.
          </div>
          <div>
            <b>Customer Obsession & Transparency:</b> We want you to be happy.
            @Justin, @etcher, and the support staff are available virtually 24/7
            to help you. If things break, we make sure to communicate our issues
            and failures.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">What is a cloud-based bot?</b>
          <div>
            Traditional bots require you to install software on your own
            computer and pay for proxies to bypass anti-bot measures. Since you
            run the bot yourself, you are also responsible for operating the bot
            correctly for each retailer, which requires a lot of patience and
            experience.
          </div>
          <br />
          <div>
            With SnailBot, <i>everything</i> is managed for you on our dedicated
            servers so that means for you: No proxies, installation, expertise,
            or headache required. Simply use our web dashboard from any device
            to configure your settings and you're all set.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">How effective is SnailBot?</b>
          <div>
            We can't guarantee success, as it will be highly dependent on what
            products you pick and what Newegg restocks, which is out of our
            control. However, we can say we've had an incredible number of
            checkouts from many happy customers and have the logs and
            testimonials to back it up. In general, we've learned to stay
            low-key about our successes in public to avoid unnecessary attention
            from Newegg.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">
            How long will it take to get my items?
          </b>
          <div>
            It's important to set proper expectations. SnailBot is not a silver
            bullet, but it can increase your chance of success. Most users get
            checkouts within a few weeks (sometimes days), but if you're only
            targeting highly coveted models like the ASUS 3080 STRIXs, it may
            take 1-3 months since Newegg does not restock them as frequently.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">What is your refund policy?</b>
          <div>
            We currently don't accept refunds. Every new user requires us to
            allocate resources dedicated to the user, which has associated
            costs. While using our services may increase your chances of a
            successful purchase, there is no guarantee, but we will try our best
            to help you in every way. @Justin, @etcher, and the support staff
            are available virtually 24/7 to help you.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">
            What products are supported? What about combo deals?
          </b>
          <div>
            We can autocheckout every product we have Newegg alerts for,
            including combos. Check out the #tracked-products channel on the
            SnailMonitor Discord.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">
            Can I choose which specific products to purchase? Can I checkout
            multiple items?
          </b>
          <div>
            Yes, you can choose the specific product(s) you want. You can also
            autocheckout multiple products simultaneously (e.g. if you want an
            ASUS STRIX RTX3080 and a 5900X). We currently limit 1 purchase per
            product SKU and max 5 successfully shipped checkouts per month
            (however, the second limit isn't enforced yet). All limits are reset
            each month. Once subscribed, you may request a limit increase if we
            approve your use case.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">
            Will you support more than Newegg in the future?
          </b>
          <div>
            Yes. Once we perfect Newegg, we'll tackle Amazon next. We believe
            it's much better to be great at a few retailers than be mediocre
            with many.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">How does it work?</b>
          <div>
            No software or proxies required. Everything is configured on our web
            dashboard, so it works on any device. Designed for ultra-fast
            checkout, SnailBot listens for the same alerts from SnailMonitor,
            which checks for Newegg restock 10 times a second. Once an alert is
            received, the bot attempts to checkout in less than a second. It has
            built-in protection to prevent duplicate purchases, while still
            being able to track multiple products at once. You will have 1-on-1
            support from @Justin and @etcher for setup and issues.
          </div>
        </div>
        <div className="mb-3">
          <b className="text-underline">
            What information is needed for the bot to function?
          </b>
          <div>
            We request you create a new Newegg account to use with the bot, and
            to provide the 3-4 digit CVV code on the back of your credit card
            which Newegg asks for during checkout. We encrypt all sensitive
            information using the latest security standards. Optionally, you may
            also create a virtual credit card using{' '}
            <a
              href="https://www.paypal.com/myaccount/debitcards/enroll/virtual-card"
              target="_blank"
              rel="nofollow"
            >
              Paypal Key
            </a>{' '}
            (setup takes 1 min) or{' '}
            <a href="https://privacy.com/" target="_blank" rel="nofollow">
              Privacy.com
            </a>{' '}
            (may take longer for approval).
          </div>
        </div>
        <div>For more questions, DM @etcher on Discord.</div>
      </Container>
    );
  }

  renderAgreementCheckboxes() {
    return (
      <div className="pricing-box-text mb-4">
        <div className="custom-control custom-checkbox mb-2">
          <input
            className="custom-control-input"
            id="checkbox1"
            checked={this.state.checkbox1}
            type="checkbox"
            onChange={() => this.handleCheckbox('checkbox1')}
          />
          <label className="custom-control-label" htmlFor="checkbox1">
            <small>
              I've read and agree to the{' '}
              <a href="/terms" target="_blank">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="/privacy" target="_blank">
                Privacy Policy
              </a>
              .
            </small>
          </label>
        </div>
        <div className="custom-control custom-checkbox mb-2">
          <input
            className="custom-control-input"
            id="checkbox2"
            checked={this.state.checkbox2}
            type="checkbox"
            onChange={() => this.handleCheckbox('checkbox2')}
          />
          <label className="custom-control-label" htmlFor="checkbox2">
            <small>
              I've read and agree to the{' '}
              <a href="/refunds" target="_blank">
                Refund Policy
              </a>
              .
            </small>
          </label>
        </div>
      </div>
    );
  }

  renderAgreements() {
    return (
      <div className="pricing-box-text mb-4">
        <small>
          By purchasing, you acknowledge you've read and agree to the{' '}
          <a href="/terms" target="_blank">
            Terms of Service
          </a>
          ,{' '}
          <a href="/privacy" target="_blank">
            Privacy Policy
          </a>
          , and{' '}
          <a href="/refunds" target="_blank">
            Refund Policy
          </a>
          .
        </small>
      </div>
    );
  }

  renderButtonsMinOneMonth() {
    return (
      <>
        <Button
          className="my-2"
          color="primary"
          type="button"
          onClick={() => this.purchase('snailbot_1mo')}
        >
          1 month - $99
        </Button>
        <Button
          className="my-2"
          color="primary"
          type="button"
          onClick={() => this.purchase('snailbot_3mo_249')}
        >
          <Badge color="success most-popular ml-1" pill>
            Recommended
          </Badge>
          <div>3 months - $249</div>
        </Button>
      </>
    );
  }

  renderButtonsMinThreeMonth() {
    return (
      <>
        <Button
          className="my-2"
          color="primary"
          type="button"
          onClick={() => this.purchase('snailbot_3mo_249')}
        >
          <Badge color="success most-popular ml-1" pill>
            16% off
          </Badge>
          <div>3 months - $249</div>
        </Button>
        <Button
          className="my-2"
          color="primary"
          type="button"
          onClick={() => this.purchase('snailbot_6mo')}
        >
          <Badge color="success most-popular ml-1" pill>
            25% off
          </Badge>
          <div>6 months - $449</div>
        </Button>
      </>
    );
  }

  // renderPurchase() {
  //   return (
  //     <Card className="bg-secondary shadow border-0">
  //       <CardBody className="px-lg-5 py-lg-5">
  //         <div className="text-center text-muted mb-1">Get Started</div>
  //         <div className="text-center mb-4">
  //           Got questions? Read the FAQ below.
  //         </div>
  //         {this.renderAgreements()}
  //         <div className="text-center">
  //           {this.state.minMonths < 3
  //             ? this.renderButtonsMinOneMonth()
  //             : this.renderButtonsMinThreeMonth()}
  //         </div>
  //       </CardBody>
  //     </Card>
  //   );
  // }

  // renderPricing() {
  //   // TODO: add FAQ section under pricing
  //   return (
  //     <div className="mt--9 pb-5 container">
  //       <div className="justify-content-center row">
  //         <div className="col-lg-5">
  //           <div className="pricing card-group flex-column flex-md-row mb-3">
  //             <div className="card-pricing bg-gradient-success zoom-in shadow-lg rounded border-0 text-center mb-4 card">
  //               {/*<div className="bg-transparent card-header"><h4*/}
  //               {/*  className="text-uppercase ls-1 text-white py-3 mb-0">SnailBot</h4></div>*/}
  //               <div className="px-lg-7 card-body">
  //                 <div className="display-1 text-white">$99</div>
  //                 <span className="text-white">per month</span>
  //                 <ul className="list-unstyled my-4">
  //                   <li>
  //                     <div className="d-flex align-items-center">
  //                       <div>
  //                         <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
  //                           <i className="fas fa-terminal"></i>
  //                         </div>
  //                       </div>
  //                       <div>
  //                         <span className="pl-2 text-white">
  //                           Checkout while AFK
  //                         </span>
  //                       </div>
  //                     </div>
  //                   </li>
  //                   <li>
  //                     <div className="d-flex align-items-center">
  //                       <div>
  //                         <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
  //                           <i className="fas fa-pen-fancy"></i>
  //                         </div>
  //                       </div>
  //                       <div>
  //                         <span className="pl-2 text-white">Hands-free</span>
  //                       </div>
  //                     </div>
  //                   </li>
  //                   <li>
  //                     <div className="d-flex align-items-center">
  //                       <div>
  //                         <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
  //                           <i className="fas fa-hdd"></i>
  //                         </div>
  //                       </div>
  //                       <div>
  //                         <span className="pl-2 text-white">
  //                           2GB cloud storage
  //                         </span>
  //                       </div>
  //                     </div>
  //                   </li>
  //                 </ul>
  //                 <button type="button" className="mb-3 btn btn-secondary">
  //                   Purchase
  //                 </button>
  //               </div>
  //               {/*<div className="bg-transparent card-footer"><a className="text-white" href="#pablo">Contact sales</a>*/}
  //               {/*</div>*/}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="d-flex justify-content-lg-center px-3 mt-5">
  //         <div>
  //           <div className="icon icon-shape bg-gradient-white shadow rounded-circle text-primary">
  //             <i className="ni ni-building text-primary"></i>
  //           </div>
  //         </div>
  //         <div className="col-lg-6">
  //           <p className="text-white">
  //             <strong>The Arctic Ocean</strong> freezes every winter and much of
  //             the sea-ice then thaws every summer, and that process will
  //             continue whatever.
  //           </p>
  //         </div>
  //       </div>
  //       <div className="row-grid justify-content-center row">
  //         <div className="col-lg-10">
  //           <div className="table-responsive">
  //             <table className="table-dark mt-5 table">
  //               <thead>
  //                 <tr>
  //                   <th className="px-0 bg-transparent" scope="col">
  //                     <span className="text-light font-weight-700">
  //                       Features
  //                     </span>
  //                   </th>
  //                   <th className="text-center bg-transparent" scope="col">
  //                     Bravo Pack
  //                   </th>
  //                   <th className="text-center bg-transparent" scope="col">
  //                     Alpha Pack
  //                   </th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 <tr>
  //                   <td className="px-0">IMAP/POP Support</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                 </tr>
  //                 <tr>
  //                   <td className="px-0">Email Forwarding</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                 </tr>
  //                 <tr>
  //                   <td className="px-0">Active Sync</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                 </tr>
  //                 <tr>
  //                   <td className="px-0">Multiple domain hosting</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">
  //                     <span className="text-sm text-light">
  //                       Limited to 1 domain only
  //                     </span>
  //                   </td>
  //                 </tr>
  //                 <tr>
  //                   <td className="px-0">Additional storage upgrade</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                 </tr>
  //                 <tr>
  //                   <td className="px-0">30MB Attachment Limit</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">-</td>
  //                 </tr>
  //                 <tr>
  //                   <td className="px-0">Password protected / Expiry links</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">-</td>
  //                 </tr>
  //                 <tr>
  //                   <td className="px-0">Unlimited Custom Apps</td>
  //                   <td className="text-center">
  //                     <i className="fas fa-check text-success"></i>
  //                   </td>
  //                   <td className="text-center">-</td>
  //                 </tr>
  //               </tbody>
  //             </table>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  renderPricing() {
    return (
      <>
        {this.state.planView === 'lite'
          ? this.renderLiteHeaderText()
          : this.renderProHeaderText()}

        {this.renderPlanDetails()}

        {this.renderHighlights()}

        {this.renderErrors()}

        {this.state.planView === 'lite' ? (
          <>{this.renderTgLitePricing()}</>
        ) : (
          <>{this.renderFullPricing()}</>
        )}

        {this.renderFAQ()}
      </>
    );
  }

  handleAmAccQtyUpdate = (e) => {
    this.setState({
      amAccQty: e.target.value,
    });
  };

  handleTgAccQtyUpdate = (e) => {
    this.setState({
      tgAccQty: e.target.value,
    });
  };

  getAmLitePricing = () => {
    if (
      !this.props.license ||
      this.props.license.licenseType === 'lite' ||
      this.props.license.licenseStatus === 'inactive'
    ) {
      return { litePrice: 33, litePricePackage: 'am_lite_33' };
    } else {
      return { litePrice: 25, litePricePackage: 'am_lite' };
    }
  };

  getTgLitePricing = () => {
    return { litePrice: 25, litePricePackage: 'tg_lite' };
  };

  renderAmLitePricing = () => {
    const { litePrice, litePricePackage } = this.getAmLitePricing();

    return (
      <Row className="justify-content-center my-4">
        <Col lg="12">
          <div
            className="tab-content pricing-tab-content"
            id="pricing-tab-content"
          >
            <div
              className="tab-pane active"
              id="monthly"
              role="tabpanel"
              aria-labelledby="monthly-tab"
            >
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <div className="card pricing-card pricing-card-preferred">
                    <div className="card-body text-center">
                      {/*<h1 className="text-center">SnailBot Lite </h1>*/}
                      {/*<div className="mb-2">*/}
                      {/*  <div>*/}
                      {/*    <small>*/}
                      {/*      Same SnailBot performance. For consoles.*/}
                      {/*    </small>*/}
                      {/*  </div>*/}
                      {/*  <div>*/}
                      {/*    <small>*/}
                      {/*      No setup fee for limited time. Limited slots*/}
                      {/*      available.*/}
                      {/*    </small>*/}
                      {/*  </div>*/}
                      {/*</div>*/}

                      <p className="h1 pricing-plan-cost mb-2">
                        ${litePrice}{' '}
                        <span className="currency">/mo per account</span>
                      </p>

                      <div className="form-group mt-3">
                        <h4 className="mb-2">
                          <b>How many Amazon accounts do you want to use?</b>
                        </h4>
                        <div className="mb-2">
                          We recommend <u>at least 3</u> for best success.
                        </div>
                        <div className="mb-2">
                          You can change this at any time.
                        </div>
                        <div className="mb-2">
                          <AmAccountModal />
                        </div>

                        <select
                          id="exampleFormControlSelect3"
                          className="form-control my-2 text-center"
                          style={{
                            cursor: 'pointer',
                            height: '60px',
                            width: '80px',
                            fontSize: '20px',
                            margin: '0 auto',
                            color: 'black',
                          }}
                          onChange={this.handleAmAccQtyUpdate}
                          defaultValue={this.state.amAccQty}
                        >
                          {Array.from({ length: 10 }, (_, i) => i + 1).map(
                            (n) => (
                              <option>{n}</option>
                            )
                          )}
                          <option disabled>Need more? (contact us)</option>
                        </select>
                      </div>

                      <div className="mb-4 text-center">
                        ${litePrice} x {this.state.amAccQty} accounts ={' '}
                        <b>${litePrice * this.state.amAccQty}/mo</b>
                      </div>

                      <hr />

                      {this.renderAgreementCheckboxes()}
                      <a
                        href="#"
                        className="btn pricing-plan-purchase-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.purchase(litePricePackage, this.state.amAccQty);
                        }}
                        style={{ color: '#5cd79c' }}
                      >
                        {this.state.isLoadingCheckout ? (
                          <Spinner className="ml-1" size="sm" color="warning" />
                        ) : (
                          'Get Started'
                        )}
                      </a>
                      {/* <div className="text-center">
                        <a
                          href="https://snailbot.io/"
                          className="pricing-plan-link"
                          target="_blank"
                        >
                          Learn more
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  renderTgLitePricing = () => {
    const { litePrice, litePricePackage } = this.getTgLitePricing();

    return (
      <Row className="justify-content-center my-4">
        <Col lg="12">
          <div
            className="tab-content pricing-tab-content"
            id="pricing-tab-content"
          >
            <div
              className="tab-pane active"
              id="monthly"
              role="tabpanel"
              aria-labelledby="monthly-tab"
            >
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <div className="card pricing-card pricing-card-preferred">
                    <div className="card-body text-center">
                      <div className="text-xl">
                        SnailBot Lite for{' '}
                        <span style={{ color: 'red' }}>Target</span>
                      </div>
                      <p className="h1 pricing-plan-cost mb-2">
                        ${litePrice}{' '}
                        <span className="currency">/mo per account</span>
                      </p>

                      <div className="form-group mt-3">
                        <h4 className="mb-2">
                          <b>How many Target accounts do you want to use?</b>
                        </h4>
                        <div className="mb-2">
                          We recommend <u>at least 3</u> for best success.
                        </div>
                        <div className="mb-2">
                          You can change this at any time.
                        </div>
                        <div className="mb-2">
                          <TgAccountModal />
                        </div>

                        <select
                          id="exampleFormControlSelect3"
                          className="form-control my-2 text-center"
                          style={{
                            cursor: 'pointer',
                            height: '60px',
                            width: '80px',
                            fontSize: '20px',
                            margin: '0 auto',
                            color: 'black',
                          }}
                          onChange={this.handleTgAccQtyUpdate}
                          defaultValue={this.state.tgAccQty}
                        >
                          {Array.from({ length: 10 }, (_, i) => i + 1).map(
                            (n) => (
                              <option>{n}</option>
                            )
                          )}
                          <option disabled>Need more? (contact us)</option>
                        </select>
                      </div>

                      <div className="mb-4 text-center">
                        ${litePrice} x {this.state.tgAccQty} accounts ={' '}
                        <b>${litePrice * this.state.tgAccQty}/mo</b>
                      </div>

                      <a
                        href="#"
                        className="btn pricing-plan-purchase-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.purchase(litePricePackage, this.state.tgAccQty);
                        }}
                        style={{ color: '#5cd79c' }}
                      >
                        {this.state.isLoadingCheckout ? (
                          <Spinner className="ml-1" size="sm" color="warning" />
                        ) : (
                          'Get Started'
                        )}
                      </a>
                      {/* <div className="text-center mb-4">
                        <a
                          href="https://snailbot.io/"
                          className="pricing-plan-link"
                          target="_blank"
                        >
                          Learn more
                        </a>
                      </div> */}

                      {this.renderAgreements()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  renderFullPricing = () => {
    return (
      <Row className="justify-content-center my-4">
        <Col lg="12">
          <div
            className="tab-content pricing-tab-content"
            id="pricing-tab-content"
          >
            <div
              className="tab-pane active"
              id="monthly"
              role="tabpanel"
              aria-labelledby="monthly-tab"
            >
              {/* <div className="row justify-content-center">
                <div className="col-md-8">{this.renderHoldUpAlert()}</div>
              </div> */}
              <div className="row justify-content-center">
                <div className="col-md-4">
                  <div className="card pricing-card">
                    <div className="card-body">
                      <h3 className="pricing-plan-title d-flex align-items-center">
                        Monthly{' '}
                      </h3>

                      <p className="h1 pricing-plan-cost mb-2">
                        99 <span className="currency">/month</span>
                      </p>

                      {this.renderSetupFee()}

                      <hr />

                      {this.renderAgreementCheckboxes()}
                      <a
                        href="#"
                        className="btn pricing-plan-purchase-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.purchase('snailbot_1mo', undefined, true);
                        }}
                        style={{ color: '#5cd79c' }}
                      >
                        {this.state.isLoadingCheckout ? (
                          <Spinner className="ml-1" size="sm" color="warning" />
                        ) : (
                          'Get Started'
                        )}
                      </a>
                      {/* <div className="text-center">
                        <a
                          href="https://about.snailbot.io/"
                          className="pricing-plan-link"
                          target="_blank"
                        >
                          Learn more
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card pricing-card pricing-card-preferred">
                    <div className="card-body">
                      <h3 className="pricing-plan-title d-flex align-items-center">
                        Quarterly{' '}
                        <span
                          className="badge badge-pill offer-badge ml-auto"
                          style={{ fontSize: '11px' }}
                        >
                          Save $50
                        </span>
                      </h3>

                      <div className="mb-1 small">
                        * <b>Recommended for best value.</b>
                      </div>

                      <p className="h1 pricing-plan-cost mb-2">
                        249 <span className="currency">/three months </span>
                        {/* <span className="h1 pricing-plan-original-cost">
                          <del>$299</del>
                        </span> */}
                      </p>

                      {this.renderSetupFee()}

                      <hr />

                      {this.renderAgreementCheckboxes()}
                      <a
                        href="#"
                        className="btn pricing-plan-purchase-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          this.purchase('snailbot_3mo_249', undefined, true);
                        }}
                        style={{ color: '#5cd79c' }}
                      >
                        {this.state.isLoadingCheckout ? (
                          <Spinner className="ml-1" size="sm" color="warning" />
                        ) : (
                          'Get Started'
                        )}
                      </a>
                      {/* <div className="text-center">
                        <a
                          href="https://about.snailbot.io/"
                          className="pricing-plan-link"
                          target="_blank"
                        >
                          Learn more
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  renderHoldUpAlert = () => {
    return (
      <Alert color="secondary" className="mb-4">
        <b className="text-warning">Hold up.</b> You have time. Before joining,
        read the{' '}
        <a className="text-underline" href="#pricingfaq">
          FAQ below
        </a>{' '}
        to see if SnailBot is right for you.
      </Alert>
    );
  };

  renderLiteHeaderText = () => {
    return (
      <div className="mt-3 mb-4">
        <div
          className="text-white"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="lead" style={{ fontSize: '32px' }}>
            SnailBot Lite for <span style={{ color: 'red' }}>Target</span>
          </div>
        </div>

        <div
          className="text-muted mb-1"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div>The easiest way to get consoles.</div>
        </div>
        <div
          className="text-muted mb-1"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div> Limited spots available.</div>
        </div>
      </div>
    );
  };

  getKeyData() {
    if (this.state.key) {
      const normalizedKey = this.state.key.toUpperCase().trim();
      return keyData[normalizedKey];
    }
    return;
  }

  renderProHeaderText = () => {
    const keyData = this.getKeyData();
    const keyExpireTime = keyData && keyData.expireTime;

    return (
      <div className="mt-3 mb-4">
        <div
          className="text-white"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="lead" style={{ fontSize: '57px' }}>
            SnailBot Pro
          </div>
        </div>

        {/* <div
          className="text-muted mb-1"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div>Taking it to the next level.</div>
        </div> */}

        <div
          className="text-muted mb-1"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {keyExpireTime ? (
            <div className="text-center">
              {this.renderCountdown(keyExpireTime)}
            </div>
          ) : null}
        </div>
        <div className="text-muted text-center">
          Don't miss the GPU, CPU, and Pokemon launches this month 🚀
        </div>
      </div>
    );
  };

  renderPlanDetails = () => {
    // if (!this.state.activeLicenseType) {
    //   if (!this.state.planView) {
    return this.renderProUpgradePlanDetails();
    //   }
    //   return this.renderNoLicensePlanDetails();
    // }

    // if (this.state.activeLicenseType === 'lite' && !this.state.planView) {
    //   return this.renderProUpgradePlanDetails();
    // }
  };

  renderNoLicensePlanDetails = () => {
    return (
      <div className="justify-content-center row my-2">
        <div className="col-lg-8">
          <div
            className="tab-content pricing-tab-content"
            id="pricing-tab-content"
          >
            <div
              className="card"
              style={{
                border: 0,
                backgroundColor: 'transparent',
                color: 'white',
              }}
            >
              <div className="card-body">
                <div>Included:</div>
                <ul className="pricing-plan-features m-0">
                  <li>
                    Access to the private {this.getSnailBotTierName()} Discord
                    and Snail Monitor premium.
                  </li>
                  <li>1-on-1 support from staff and developers at any time.</li>
                  {/*<li>*/}
                  {/*  Community resources like our eBay scammer database, tax*/}
                  {/*  tips, and more.*/}
                  {/*</li>*/}
                  <li>
                    Automatic renewal. Cancel, pause, or resume your
                    subscription at any time for free.
                  </li>
                  <li>
                    30-day money-back guarantee (see refund policy for details).
                  </li>
                </ul>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderProUpgradePlanDetails = () => {
    return (
      <div className="justify-content-center row my-4">
        <div className="col-lg-8">
          <div
            className="tab-content pricing-tab-content"
            id="pricing-tab-content"
          >
            <div
              className="card"
              style={{
                border: 0,
                backgroundColor: 'transparent',
                color: 'white',
              }}
            >
              <div className="card-body">
                <div>Included:</div>
                <ul className="pricing-plan-features m-0">
                  <li>
                    RTX 5000s, Pokemon cards, TCGs, and over 400+ products
                    supported. We continually track all profitable items, and
                    you can request any product to be added.
                  </li>
                  <li>
                    Use up to 6 Amazon accounts and 2 Target accounts at the
                    same time.
                  </li>
                  <li>
                    Access to the private SnailBot Pro Discord and the community
                    of the most seasoned resellers.
                  </li>
                </ul>
                <br />
                <div>Additionally: </div>
                <ul className="pricing-plan-features m-0">
                  <li>
                    30-day money-back guarantee (see refund policy for details).
                  </li>
                  <li>1-on-1 support from staff and developers at any time.</li>
                  <li>
                    Access to our guides for avoiding sales tax, getting
                    cashback, our eBay scammer database, and more.
                  </li>
                  {/* <li>
                    Automatic renewal. Cancel, pause, or resume your
                    subscription at any time for free.
                  </li>
                  <li>
                    Ability to transfer your license if we make SnailBot
                    tradable in the future.
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getSnailBotTierName = () => {
    if (this.state.planView === 'lite') {
      return 'SnailBot Lite';
    } else {
      return 'SnailBot Pro';
    }
  };

  renderHighlights = () => {
    return (
      <div className="mb-6">
        <div
          className="text-white text-center"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="lead">
            Join other SnailBot users making <i>thousands</i> in profit each
            month.
          </div>
        </div>

        <div
          className="text-muted mb-1"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div>
            <small>
              (
              <a
                href="https://x.com/SnailBotIO/status/1900306375202529670"
                target="_blank"
              >
                see the success on X/Twitter
              </a>
              )
            </small>
          </div>
        </div>

        <div
          className="text-white text-center"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="lead">30-day money-back guarantee*</div>
        </div>

        <div
          className="text-muted text-center"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div>
            <small>*See refund policy for details.</small>
          </div>
        </div>
      </div>
    );
  };

  renderFAQ = () => {
    return (
      <div className="justify-content-center row">
        <div className="col-lg-8">
          <div
            className="tab-content pricing-tab-content"
            id="pricing-tab-content"
          >
            <div
              className="card"
              style={{
                border: 0,
                backgroundColor: 'transparent',
                color: 'white',
              }}
            >
              <div className="card-body">
                <div id="pricingfaq" className="display-4">
                  FAQ
                </div>
                <br />

                {this.state.planView === 'lite' ? (
                  <>
                    <FAQItem question="What's SnailBot Lite?">
                      SnailBot Lite is a hands-free cloud service that
                      automatically purchases consoles (e.g. PS5s) for you when
                      they restock. Lite users may be invited to upgrade to
                      SnailBot Pro which has access to more items like GPUs and
                      trading cards.
                    </FAQItem>

                    <FAQItem question="How does SnailBot work on Target?">
                      <>
                        On Target, consoles restock 24/7. Target typically only
                        allows consoles to be purchased for in-store pickup, so
                        SnailBot will ask for your ZIP code and attempt to
                        purchase items for pickup at Target stores near you.
                        <br />
                        <br />
                        SnailBot handles EVERYTHING for you so you don't need
                        any proxies, software, or manual actions to get
                        checkouts on Target.
                        <br />
                        <br />
                        SnailBot also supports using the Target RedCard for
                        purchases.
                      </>
                    </FAQItem>

                    <FAQItem question="How's the customer success?">
                      Our users got ~785 PS5s in the past 2 weeks of November,
                      averaging 5 PS5s{' '}
                      <b>
                        <i>per</i>
                      </b>{' '}
                      Target account. Users who use multiple accounts can
                      acquire a large number of PS5s.
                    </FAQItem>

                    <FAQItem question="Why only consoles?">
                      Our Lite tier is restricted to consoles because other
                      items like GPUs have much lower stock so we don't want to
                      dramatically increase competition for SnailBot Pro users.
                    </FAQItem>
                  </>
                ) : null}

                {this.state.planView !== 'lite' ? (
                  <>
                    {/* {this.state.activeLicenseType === 'lite' ? (
                      <FAQItem question="What will happen to my Lite instances when I upgrade to Pro?">
                        Up to 5 Lite instances will automatically convert to Pro
                        instances so the transition is seamless and requires no
                        additional setup. In total, you will have the same
                        number of Lite instances as before in addition to your
                        new Pro instances. For example with Amazon, if you have
                        5 Lite instances and you upgrade to Pro, those 5 will be
                        converted to 5 Pro instances and you will get 5 new
                        empty Lite instances, for 10 total.
                      </FAQItem>
                    ) : null} */}

                    <FAQItem
                      question="What makes SnailBot different?"
                      defaultOpen
                    >
                      SnailBot is a cloud service that handles everything for
                      you so you can get checkouts without effort. You don't
                      need proxies, servers, or any software. Simply choose the
                      products you want and we'll handle the rest.
                    </FAQItem>

                    <FAQItem question="How does the 30-day money-back guarantee work?">
                      Since we stand by our product - within 30 days of
                      purchase, if you're not satisfied with SnailBot, you may
                      request a full refund (including setup fee) minus 5% for
                      payment processing fees, and minus the estimated profit
                      for checkouts you've accrued (to avoid abuse).
                    </FAQItem>

                    <FAQItem question="Why the setup fee?">
                      <>
                        The setup fee covers lifetime provisioning of dedicated
                        high-grade proxies, servers, upgrades, and 1-on-1
                        support. You may pause and resume your subscription
                        without paying the setup fee again.
                        <br />
                        <br />
                        Although it's a large initial investment, most users
                        recoup the cost fairly quickly.
                      </>
                    </FAQItem>

                    <FAQItem question="What retailers are supported?">
                      Amazon and Target. You can run 6 Amazon accounts and 2
                      Target accounts simultaneously, each with their own
                      dedicated resources.
                    </FAQItem>

                    <FAQItem question="What products are supported?">
                      RTX 5000s, Pokemon cards, TCGs, and over 400+ products are
                      supported. We continually track all profitable items, and
                      you can request any product to be added.
                    </FAQItem>

                    <FAQItem question="What is the customer success like in 2025?">
                      Members are checking out thousands of RTX 5000s, Pokemon
                      cards, and other profitable items every week.
                      <br />
                      <br />
                      <a href="https://x.com/SnailBotIO" target="_blank">
                        Check our X/Twitter to see our customer success.
                      </a>
                    </FAQItem>

                    <FAQItem question="How do you keep success evenly distributed amongst users?">
                      Our system is designed for fairness. Every account tries
                      to checkout at the same time. We continually track and
                      review metrics for customer success to make adjustments
                      when needed. Understand that it's in our best interest to
                      deliver value to as many of ours users as possible so we
                      have returning customers. Making sure
                      <i> everyone</i> gets checkouts is our top priority.
                    </FAQItem>

                    <FAQItem question="Are licenses transferable?">
                      Not at the moment, but possibly in the future.
                    </FAQItem>

                    <FAQItem question="Do you still offer SnailBot Lite?">
                      No, we've discontinued the Lite tier and all our focus is
                      on SnailBot Pro.
                    </FAQItem>

                    <FAQItem question="What does the future hold for SnailBot?">
                      <>
                        We value longevity of our service and customer success
                        for years for come. We've built a solid foundation since
                        2020 and we will continue to serve our customers for
                        years to come.
                        <br />
                        <br />
                        Our vision is to <b>completely dominate</b> the supply
                        of exclusive items across all major online retailers.
                      </>
                    </FAQItem>
                  </>
                ) : null}

                <FAQItem question="Got more questions?">
                  <>
                    See our{' '}
                    <a href="https://snailbot.io/#faq" target="_blank">
                      public FAQ
                    </a>{' '}
                    for more info. You can also create a ticket on our{' '}
                    <a href="https://discord.gg/sW2T7kA9w8" target="_blank">
                      Discord
                    </a>{' '}
                    or email support@snailbot.io
                  </>
                </FAQItem>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSetupFee = () => {
    return (
      <div className="pricing-box-text mb-4">
        <span className="text-underline">One-time Setup Fee:</span>{' '}
        {/* <small>
          (
          <a href="#pricingfaq" className="text-underline">
            Why?
          </a>
          )
        </small>{' '} */}
        <div>
          <span className="">
            <b>$999</b> <del>$3699</del> (73% off)
          </span>{' '}
        </div>
        <div className="small mt-2">
          Setup fee covers lifetime provisioning of dedicated high-grade
          proxies, servers, upgrades, and 1-on-1 support. You may pause and
          resume your subscription without paying the setup fee again.
        </div>
        <div className="mt-2">
          <b>30-day money-back guarantee (see refund policy for details)</b>
        </div>
      </div>
    );
  };

  renderKeyForm() {
    return (
      <Row className="justify-content-center mt-4">
        <Col lg="5" md="7">
          {this.renderErrors()}
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">
                No invite?{' '}
                <a href="https://forms.gle/5sRn6JrFdvCknTnG9" target="_blank">
                  {' '}
                  Join the SnailBot waitlist
                </a>
                .
              </div>
              <div className="text-center text-muted mb-4">
                Let's begin. Enter your invite code.
              </div>
              <Form role="form" onSubmit={this.validateKey}>
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-lock-circle-open" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Invite Code"
                      defaultValue={this.state.key}
                      type="text"
                      autoComplete="new-password"
                      onChange={this.handleKeyInput}
                    />
                  </InputGroup>
                </FormGroup>
                <div className="text-center">
                  <Button
                    className="my-2"
                    color="primary"
                    type="button"
                    onClick={this.validateKey}
                  >
                    Redeem
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  acceptCheaterWarning = () => {
    this.setState({
      acceptedCheaterWarning: true,
    });
  };

  acceptDisclaimer = () => {
    this.setState({
      acceptedDisclaimer: true,
    });
  };

  renderIPData = () => {
    const dataParts = [];
    if (this.state.location) dataParts.push(this.state.location);
    if (this.state.ip) dataParts.push(this.state.ip);
    if (dataParts.length === 0) return null;
    const dataStr = dataParts.join(' - ');
    return (
      <div className="my-3 text-center">
        <small>{dataStr}</small>
      </div>
    );
  };

  renderCheaterWarning() {
    return (
      <Row className="justify-content-center mt-4">
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">Entry Enforced</div>
              <Form role="form" onSubmit={this.acceptCheaterWarning}>
                <div className="mb-3">
                  <div className="mb-3">
                    <b>SnailBot is invite only.</b>
                  </div>
                  <div className="mb-3">
                    Buying, selling, or sharing a SnailBot license is strictly
                    forbidden.
                  </div>
                  <div className="mb-3">
                    If you weren't <b>personally</b> invited from the waitlist
                    or one of our partnered groups, <b>we will catch you</b>.
                  </div>
                  <div>
                    Please be fair to the people who've been waiting for months.
                  </div>
                  {this.renderIPData()}
                </div>
                <div className="text-center">
                  <Button
                    className="my-2"
                    color="primary"
                    type="button"
                    onClick={this.acceptCheaterWarning}
                  >
                    Ok, I was invited
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  renderDisclaimer() {
    return (
      <Row className="justify-content-center mt-4">
        <Col lg="5" md="7">
          <Card className="bg-secondary shadow border-0 card-orange-outline">
            <CardBody className="px-lg-5 py-lg-5">
              <div className="text-center text-muted mb-4">Disclaimer</div>
              <Form role="form" onSubmit={this.acceptDisclaimer}>
                <div className="mb-3">
                  <div className="mb-3">
                    <b>SnailBot is not for everyone.</b>
                  </div>
                  <div className="mb-3">
                    Despite overwhelming demand these past years, we chose to
                    keep our community exclusive by prioritizing{' '}
                    <b>long-term customers</b> and{' '}
                    <b>our pricing reflects that</b>.
                  </div>
                  <div className="mb-3">
                    Longevity of our service and customer success is important
                    to us. We want to build relationships with customers that
                    lasts <b>years</b>. That is the timeframe you should be
                    thinking about.
                  </div>
                  <div className="mb-3">
                    <b>Expectations should be kept low.</b> There is{' '}
                    <b>no guarantee</b> you will make back your investment. If
                    you cannot take that risk, SnailBot is not for you and we
                    urge you to look at other services.
                  </div>
                </div>
                <div className="text-center">
                  <Button
                    className="my-2"
                    color="primary"
                    type="button"
                    onClick={this.acceptDisclaimer}
                  >
                    Ok, I understand
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  renderFlow = () => {
    if (
      // Let anyone into the Lite sub screen if they have an existing license (active or not)
      this.props.license &&
      this.state.planView === 'lite'
      // Allow non-Lite license holders to enter Pro sub screen
      // For now, Pro users must reactivate their license through support
      // (this.props.license && this.props.license.licenseType !== 'lite')
    ) {
      // no-op
    } else {
      if (
        !this.state.activeLicenseType ||
        (this.state.activeLicenseType !== 'pro' &&
          this.props.license &&
          !this.props.license.isProEligible)
      ) {
        if (!this.state.validKey) {
          return this.renderKeyForm();
        }
      }
    }

    // TODO: re-enable
    if (this.state.planView !== 'lite') {
      //   if (!this.state.acceptedCheaterWarning && !this.state.activeLicenseType) {
      //     return this.renderCheaterWarning();
      //   }
      if (!this.state.acceptedDisclaimer) {
        return this.renderDisclaimer();
      }
    }

    return this.renderPricing();
  };

  renderManageSub() {
    return (
      <Button
        color="primary"
        type="button"
        href={`${utils.getEndpoint()}/stripe/customer-portal`}
        target="_blank"
        className="mb-3"
      >
        Manage Subscription
      </Button>
    );
  }

  renderCountdown = (expireTime) => {
    if (Date.now() > expireTime) return null;
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
      // Render a countdown
      return (
        <span>
          {days}d {hours}h {minutes}m {seconds}s
        </span>
      );
    };
    return (
      <div className="text-center">
        <div>
          Invite expires in:{' '}
          <b>
            <Countdown date={expireTime} renderer={renderer} />
          </b>
        </div>
      </div>
    );
  };

  renderHeader = () => {
    return (
      <div className="header py-2 mb-2 sub-header">
        <Container>
          <div className="header-body text-center mt-4 mb-3">
            <Row className="justify-content-center">
              <Col lg="5" md="6">
                <img
                  alt="SnailBot"
                  className="navbar-brand-img"
                  style={{ maxHeight: '7rem' }}
                  src={`${process.env.PUBLIC_URL}/images/snailbotlogo_128.png`}
                />
                <h1 className="text-white">SnailBot</h1>
                {/*<p className="text-lead text-white">*/}
                {/*  Ready to take back your time?*/}
                {/*</p>*/}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    );
  };

  renderResubFlow() {
    if (!this.props.license) {
      this.setState({
        redirect: '/',
      });
      return;
    }

    const isProResub =
      this.props.license.licenseStatus !== 'active' &&
      !this.props.license.licenseType;

    const isNoOptionAvail = !isProResub;

    return (
      <Row className="justify-content-center my-4">
        <Col lg="12">
          <div className="mb-5">
            <div
              className="text-white"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className="lead mt-0" style={{ fontSize: '33px' }}>
                Welcome back
              </div>
            </div>

            <div
              className="text-muted mb-1"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className="text-center">
                <div className="mb-2">You may resubscribe below.</div>
              </div>
            </div>
          </div>
          <div
            className="tab-content pricing-tab-content"
            id="pricing-tab-content"
          >
            <div
              className="tab-pane active"
              id="monthly"
              role="tabpanel"
              aria-labelledby="monthly-tab"
            >
              {isProResub ? this.renderProResub() : null}
              {/*{isNoOptionAvail ? (*/}
              {/*  <div className="text-center text-white">*/}
              {/*    You cannot resubscribe at this time. Please contact us on*/}
              {/*    Discord or support@snailbot.io*/}
              {/*  </div>*/}
              {/*) : null}*/}
            </div>
          </div>
          <div className="text-center mb-4 text-white">
            Got questions? Create a ticket on our{' '}
            <a href="https://discord.gg/GQ5hU6N954" target="_blank">
              Discord
            </a>{' '}
            or email support@snailbot.io
          </div>
        </Col>
      </Row>
    );
  }

  renderProResub() {
    return (
      <div className="row justify-content-center mb-5">
        <div className="col-md-8">
          <div className="card pricing-card pricing-card-preferred">
            <div className="card-body">
              <h1>SnailBot Pro</h1>

              <div className="mb-3">
                <ul>
                  <li>
                    RTX 5000s, Pokemon cards, TCGs, and over 400+ products
                    supported. We continually track all profitable items, and
                    you can request any product to be added.
                  </li>
                  <li>
                    Use up to 6 Amazon accounts and 2 Target accounts at the
                    same time.
                  </li>
                </ul>
              </div>

              <div className="text-center mb-2">
                <div>
                  <b className="text-success">Resubscribe:</b>
                  <div className="text-muted py-2">
                    You don't need to pay the setup fee again since you already
                    did.
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <a
                  href="#"
                  className="btn pricing-plan-purchase-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    this.purchase('snailbot_1mo');
                  }}
                  style={{
                    color: 'white',
                    border: 'none',
                    backgroundColor: 'rgb(92, 215, 156)',
                  }}
                >
                  {this.state.isLoadingCheckout ? (
                    <Spinner className="ml-1" size="sm" color="warning" />
                  ) : (
                    <div>
                      <div>$99/month</div>
                    </div>
                  )}
                </a>
              </div>

              <div>
                <a
                  href="#"
                  className="btn pricing-plan-purchase-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    this.purchase('snailbot_3mo_249');
                  }}
                  style={{
                    color: 'white',
                    border: 'none',
                    backgroundColor: 'rgb(92, 215, 156)',
                  }}
                >
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ right: '-12px', top: '-11px' }}
                  >
                    Recommended
                  </span>
                  {this.state.isLoadingCheckout ? (
                    <Spinner className="ml-1" size="sm" color="warning" />
                  ) : (
                    <div>
                      <div>
                        <span
                          style={{
                            color: 'black',
                            textDecoration: 'line-through',
                          }}
                        >
                          <span style={{ color: 'white' }}>$299</span>
                        </span>{' '}
                        $249 for 3 months
                      </div>
                      <small>SAVE $50</small>
                    </div>
                  )}
                </a>

                <div class="text-center mt-4">
                  <div>
                    Join other SnailBot users making <i>thousands</i> in profit
                    this month
                  </div>
                  <div className="mb-3">
                    (
                    <a
                      href="https://x.com/SnailBotIO/status/1900306375202529670"
                      target="_blank"
                    >
                      see the success on X/Twitter
                    </a>
                    )
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLiteResub() {
    return (
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card pricing-card pricing-card-preferred">
            <div className="card-body">
              <h1>SnailBot Lite Target</h1>

              <div className="mb-3">
                <ul>
                  <li>Get access to consoles on Target</li>
                  <li>
                    No setup fee. Pay only for the number of Target accounts you
                    want to use.
                  </li>
                </ul>
              </div>

              <div className="mb-4">
                <a
                  href="#"
                  className="btn pricing-plan-purchase-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ planView: 'lite' });
                  }}
                  style={{
                    color: 'white',
                    border: 'none',
                    backgroundColor: 'rgb(92, 215, 156)',
                  }}
                >
                  <div>Get Started</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderRedirect()}
        {this.renderAlreadySubbedModal()}
        <div className="main-content">
          <AdminNavbar {...this.props} brandText="" />
          {this.renderHeader()}
          <Container className="pb-5">
            {this.props.license?.licenseStatus === 'active' ? (
              <Row className="justify-content-center my-4">
                <Col lg="12">
                  <div className="text-center">{this.renderManageSub()}</div>
                </Col>
              </Row>
            ) : null}
            {!this.state.planView &&
            this.props.license &&
            this.props.license.licenseStatus !== 'active' &&
            !this.props.license.licenseType
              ? this.renderResubFlow()
              : this.renderFlow()}
          </Container>
        </div>
        <AuthFooter />
      </>
    );
  }
}

export default Subscribe;
